/**
 * @type {String}
 */
export const lcSideFilterFragment = `
  ... on ComponentLearningCenterSideFilter {
    name
      filtersCollection(limit:5) {
        items {
          name
          displayName
          filtersCollection(limit:50) {
            items {
              name
              displayName
            }
          }
        }
      }
  }`;
